import { activityCategoryDictionary } from "@/api/activities";
import type { IGroupableCategory } from "@medoma/models/activities";
import { useLingui } from "@lingui/react/macro";
import styles from "./cardHeadingCancelled.module.scss";
import { CardHeading } from "./cardHeading";

export const CardHeadingCancelled = ({
  category,
}: {
  category: IGroupableCategory;
}) => {
  const { t } = useLingui();
  return (
    <div className={styles.strikethrough}>
      <CardHeading
        category={category}
        title={`${t(activityCategoryDictionary[category])} · ${t`Avbokat`}`}
        formattedTimespan={null}
      />
    </div>
  );
};
